<template>
	<div class="spinner" :class="containerClasses">
		<figure class="spinner__center" :class="centerClasses">
			<span class="spinner__anim" :class="animClasses"></span>
			<span class="spinner__anim spinner__anim--angle" :class="animClasses"></span>
		</figure>
	</div>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    contained: {
      type: Boolean,
      required: false,
      default: false
    },
    lightColor: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    containerClasses() {
      return [
        { 'spinner--contained': this.contained,
          'spinner--light': this.lightColor }
      ]
    },
    centerClasses() {
      return [
        { 'spinner__center--contained': this.contained,
          'spinner__center--light': this.lightColor }
      ]
    },
    animClasses() {
      return [
        { 'spinner__anim--contained': this.contained,
          'spinner__anim--light': this.lightColor }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// Spinner.vue?24cf5300